<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">任务日期</span>
        <el-date-picker v-model="timeValue"  size="small" type="daterange" style="width: 280px;" range-separator="至"
                          start-placeholder="开始日期" end-placeholder="结束日期"
                          align="right" value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <input-select selectTitle="任务状态" :selectKey="'taskStatus'" :selectData="taskTypeList" @search="search"/>
      <input-search placeholder="任务名称/巡更班组" @search="searchKey" />
    </div>

    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @toCurrentPage="toCurrentPage" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :hasOperation="false"  @seeExample="seeExample"/>

    <el-dialog
      title="巡更详情"
      :visible.sync="dialogVisible"
      width="60%"
      style="height:100%"
      :before-close="handleClose">
      <table-main :selection="false" :tableHeight="500" :tableHead="tableHead2" :tableData="tableData2"  :total="total2" :pageNum="requestData2.pageNum" :pageSize="requestData2.pageSize" :hasOperation="false" @changePagination="changePagination2"/>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm" size="small">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/KeepWatch";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "patrol-task",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧巡更",
          name: "patrol-point-manage"
        },
        {
          value: "巡更任务"
        }
      ],
      exportUrl: "",
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000);
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      tableHead: [
        {
          prop: "taskName",
          label: "任务名称"
        },
        {
          prop: "teamName",
          label: "巡更班组"
        },
        {
          prop: "timeTypeText",
          label: "巡更类型"
        },
        {
          prop: "timeQuantum",
          label: "巡更时间区间"
        },
        {
          prop: "patrolPointCount",
          label: "计划巡更点数"
        },
        {
          prop: "completed",
          label: "已完成"
        },
        {
          prop: "omission",
          label: "未巡"
        },
        {
          prop: "actualPatrolTime",
          label: "巡更详情",
          example: true
        },

        {
          prop: "taskStatusText",
          label: "任务状态",
          showColor: true
        }
      ],
      tableHead2: [
        {
          prop: "patrolRouteName",
          label: "巡更路线"
        },
        {
          prop: "patrolPointName",
          label: "巡更点"
        },
        {
          prop: "patrolStatusText",
          label: "巡更状态"
        },
        {
          prop: "personName",
          label: "巡更人员"
        },
        {
          prop: "actualPatrolTime",
          label: "巡更时间"
        }
      ],
      tableData: [],
      tableData2: [],
      total: 0,
      total2: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      timeValue: [],
      requestData: {
        startTime: "",
        endTime: "",
        searchKey: ""
      },
      requestData2: {
        pageNum: 1,
        pageSize: 10
      },
      taskTypeList: [
        {
          label: "全部",
          key: ""
        },
        {
          label: "正常",
          key: "0"
        },
        {
          label: "异常",
          key: "1"
        }
      ],
      dialogVisible: false
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getCreatTime();
  },
  activated() {
    this.getPage();
  },
  methods: {
    getCreatTime() {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour =
        nowDate.getHours() < 10 ? "0" + nowDate.getHours() : nowDate.getHours();
      let minute =
        nowDate.getMinutes() < 10
          ? "0" + nowDate.getMinutes()
          : nowDate.getMinutes();
      let second =
        nowDate.getSeconds() < 10
          ? "0" + nowDate.getSeconds()
          : nowDate.getSeconds();
      this.timeValue[0] = `${year}-${month}-${date}`;
      this.timeValue[1] = `${year}-${month}-${date}`;
      this.getPage();
    },
    beforeDownload() {
      this.exportUrl = `${api.exportCustom}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&customIntendType=${this.requestData.customIntendType}`;
    },
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      if (this.timeValue) {
        this.requestData.startTime = this.timeValue[0] || "";
        this.requestData.endTime = this.timeValue[1] || "";
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }
      this.$axios
        .post(api.getPatrolTaskPage, reqData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map(v => {
              v.timeQuantum = v.rosterStartTime + "-" + v.rosterEndTime;
              if (v.timeType === "0") {
                v.timeTypeText = "按日";
              } else if (v.timeType === "1") {
                v.timeTypeText = "按周";
              } else {
                v.timeTypeText = "";
              }

              if (v.taskStatus === "0") {
                v.taskStatusText = "正常";
                v.fontColorToPeople = "#18887B";
                v.backgroundColor = "#E4F0EF";
              } else {
                v.taskStatusText = "异常";
                v.fontColorToPeople = "#DE3333";
                v.backgroundColor = "#F5E7E7";
              }
            });
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取记录失败"));
    },
    getDetailPage() {
      this.$axios
        .post(api.getPatrolTaskDetailPage, this.requestData2)
        .then(res => {
          let data = res.data.data.list;
          data.map(v => {
            if (v.patrolStatus == "0") {
              v.patrolStatusText = "未巡更";
            } else {
              v.patrolStatusText = "已巡更";
            }
          });
          this.total2 = res.data.data.total;
          this.tableData2 = data;
        })
        .catch(errorHandler("获取详情失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changePagination2(data) {
      this.requestData2.pageNum = data[0];
      this.requestData2.pageSize = data[1];
      this.getDetailPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    toCurrentPage(code) {
      this.$router.push({
        path: `/site_reservation/site_current/${code}`
      });
    },
    changeTimeValue() {},
    seeExample(data) {
      this.dialogVisible = true;
      this.requestData2.code = data.code;
      this.getDetailPage();
    },
    handleClose() {
      this.dialogVisible = false;
      this.requestData2.searchKey = "";
    },
    confirm() {
      this.dialogVisible = false;
    }
  },

  watch: {
    timeValue() {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/KeepWatch/PatrolTask/PatrolTask.vue